import type { ContentType } from './contentTypeConstants';
import { VALID_OPERATION_TARGETS } from './contentTypeConstants';

export type Operation = {
	operation: string | null;
	targetType: string | null;
} | null;

type ContentTypes = string | null | undefined;

const isValidContentType = (contentType: ContentTypes): boolean => {
	if (!contentType) {
		return false;
	}
	return VALID_OPERATION_TARGETS.includes(contentType as ContentType);
};

export const canArchiveContent = (operations: Operation[] | null | undefined) => {
	if (operations) {
		return operations.some((singleOperation) => {
			return (
				isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'archive'
			);
		});
	}
	return false;
};

export const canDeleteContent = (operations: Operation[] | null | undefined) => {
	if (operations) {
		return operations.some((singleOperation) => {
			return (
				isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'delete'
			);
		});
	}
	return false;
};

export const canRestoreContent = (operations: Operation[]) => canArchiveContent(operations);

export const canEditContentArchiveNote = (operations: Operation[]) => canArchiveContent(operations);
